import i18next from 'i18next';
import { Icon } from '@iconify/react';
import ratingIcon from '@iconify/icons-eva/star-fill';

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const ratingsSystemConfig = () => ({
  title: i18next.t('ratingSystem.sidebar'),
  path: '/products/ratings-system',
  icon: getIcon(ratingIcon),
  children: [
    // {title:"DashBoard", path: '/products/ratings-system/dashboard'},
    { title: i18next.t('ratingSystem.reports.title'), path: '/products/ratings-system/reports' },
    { title: 'Lojas', path: '/products/ratings-system/stores' },
  ],
});

export default ratingsSystemConfig;
